import React, { useState, useEffect } from 'react';

import { object, string, number } from 'yup';
import { currentYear } from '../../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import CustomerDetails from '../AddleadComponent/CustomerDetails/CustomerDetails';
import {
  customerDetails,
  setLoanProducts,
  updateCustomerDetails
} from '../../../common/constants/api';
import 'react-toastify/dist/ReactToastify.min.css';
import { navigate } from 'gatsby';
import Toast from '../../../common/components/Toast/Toast';
import { setApplicantionInfo } from '../../../common/utils/applicantionInfo';

let LeadId;
export const Lead = () => {
  return LeadId;
};

let pincode;
export const pin = () => {
  return pincode;
};

let Steps = [
  {
    id: 'CustomerDetails',
    component: CustomerDetails,
    initialValues: {
      Name: '',
      middleName: '',
      lastName: '',
      email: '',
      mobile: '',
      pincode: '',
      EnquiryStatus: '',
      ProductId: '',
      date: {
        value: '',
        label: 'Date'
      },
      month: {
        value: '',
        label: 'Month'
      },
      year: {
        value: String(parseInt(currentYear) - 18),
        label: String(parseInt(currentYear) - 18)
      },
      loanamount: '',
      comments: '',
      gender: ''
    },
    validationSchema: object().shape({
      Name: string()
        .min(1, 'Too Short!')
        .max(50, 'Too Long!')
        .required('Required'),
      lastName: string()
        .min(1, 'Too Short!')
        .max(50, 'Too Long!')
        .required('Required'),

      pincode: string().when('EnquiryStatus', {
        is: 'NEW_LEAD_ADDED',
        then: string().required('Required')
      }),
      gender: string().when('EnquiryStatus', {
        is: 'NEW_LEAD_ADDED',
        then: string().required('Required')
      }),
      email: string().when('EnquiryStatus', {
        is: 'NEW_LEAD_ADDED',
        then: string()
          .required('Required')
          .max(50, 'Email address is Too Long!')
          .matches(
            /^([a-z 0-9\.-_]+)@([a-z 0-9-]+).([a-z]{2,8})(.[a-z]{2,8})?$/,
            'Please Enter Valid Email Id'
          )
      }),
      mobile: string()
        .required('Required')
        .max(10)
        .matches(/([6-9]\d{9})/, 'Mobile should be 10 digit number'),
      loanamount: string()
        .when('ProductId', {
          is: '12',
          then: string()
            .required('Required')
            .test(
              'loanamount',
              'Amount should be in between 50,000 and 25 Lakh',
              function(val) {
                if (val != undefined) {
                  let checkAmount = parseInt(val.replace(/,/g, ''));
                  if (checkAmount >= 50000 && checkAmount <= 2500000)
                    return true;
                  else return false;
                }
              }
            )
        })
        .when('ProductId', {
          is: '13',
          then: string()
            .required('Required')
            .test(
              'loanamount',
              'Amount should be in between 50,000 and 1Cr',
              function(val) {
                if (val != undefined) {
                  let checkAmount = parseInt(val.replace(/,/g, ''));
                  if (checkAmount >= 50000 && checkAmount <= 10000000)
                    return true;
                  else return false;
                }
              }
            )
        })
        .when('ProductId', {
          is: '14',
          then: string()
            .required('Required')
            .test(
              'loanamount',
              'Amount should be in between 10,000 and 5 Lakh',
              function(val) {
                if (val != undefined) {
                  let checkAmount = parseInt(val.replace(/,/g, ''));
                  if (checkAmount >= 10000 && checkAmount <= 500000)
                    return true;
                  else return false;
                }
              }
            )
        })
        .when('ProductId', {
          is: '1',
          then: string()
            .required('Required')
            .test(
              'loanamount',
              'Amount should be in between 10 Lakh and 99 Cr',
              function(val) {
                if (val != undefined) {
                  let checkAmount = parseInt(val.replace(/,/g, ''));
                  if (checkAmount >= 1000000 && checkAmount <= 99000000)
                    return true;
                  else return false;
                }
              }
            )
        })
        .when('ProductId', {
          is: '2',
          then: string()
            .required('Required')
            .test(
              'loanamount',
              'Amount should be in between 10 Lakh and 99 Cr',
              function(val) {
                if (val != undefined) {
                  let checkAmount = parseInt(val.replace(/,/g, ''));
                  if (checkAmount > 1000000 && checkAmount < 99000000)
                    return true;
                  else return false;
                }
              }
            )
        }),
      date: object().when('EnquiryStatus', {
        is: 'NEW_LEAD_ADDED',
        then: object().shape({
          value: string().required('Required')
        })
      }),
      month: object().when('EnquiryStatus', {
        is: 'NEW_LEAD_ADDED',
        then: object().shape({
          value: string().required('Required')
        })
      }),
      year: object().when('EnquiryStatus', {
        is: 'NEW_LEAD_ADDED',
        then: object().shape({
          value: string().required('Required')
        })
      }),
      ProductId: string().when('EnquiryStatus', {
        is: 'NEW_LEAD_ADDED',
        then: string().required('Required')
      }),
      EnquiryStatus: string().required('Required')
    }),
    enableReinitialize: true,
    onAction: async (sectionValues, formValues) => {
      let body = {
        name: {
          firstName: sectionValues.Name,
          middleName: sectionValues.middleName,
          lastName: sectionValues.lastName
        },
        email: sectionValues.email != '' ? sectionValues.email : null,
        phone: sectionValues.mobile,
        pincode: sectionValues.pincode,
        leadStatus: sectionValues.EnquiryStatus,
        productId: sectionValues.ProductId,
        gender: sectionValues.gender,
        dob: new Date(
          `${sectionValues.year.value}-${sectionValues.month.value}-${sectionValues.date.value}`
        ),
        loanAmount: parseInt(sectionValues.loanamount.replace(/\,/g, ''), 10),
        comment: sectionValues.comments
      };
      localStorage.setItem('ApplicantUserKycInfo', JSON.stringify(body));
      const url = new URL(window.location.href);
      if (url.href.includes('leadId')) {
        const leadId = url.searchParams.get('leadId');
        if (
          sectionValues.EnquiryStatus == 'NOT_INTERESTED' ||
          sectionValues.EnquiryStatus == 'FOLLOW_UP'
        ) {
          Toast(
            'warning',
            'Lead can be changed to Interested Only!',
            3000,
            'top-center'
          );
          navigate('app/dashboard');
          throw new Error('NO_NEXT_STEP');
        } else {
          updateCustomerDetails(leadId, body)
            .then(data => {
              console.log(data);
            })
            .catch(err => {
              throw new Error(err?.response?.data?.message);
            });
        }
      } else {
        await customerDetails(body)
          .then(data => {
            LeadId = data.leadId;
            data.applicationStatus = 'New Lead';
            data.mainApplicant = true;
            setApplicantionInfo(data);
          })
          .catch(err => {
            throw new Error(err?.response?.data?.message);
          });
      }
      if (
        sectionValues.EnquiryStatus == 'NOT_INTERESTED' ||
        sectionValues.EnquiryStatus == 'FOLLOW_UP'
      ) {
        Toast('success', 'Lead has been added!', 3000, 'top-center');
        navigate('app/dashboard');
        throw new Error('NO_NEXT_STEP');
      } else if (sectionValues.ProductId == 2) {
        Toast('success', 'Lead has been added!', 3000, 'top-center');
        navigate('app/LAP');
        throw new Error('NO_NEXT_STEP');
      } else {
        Toast(
          'success',
          <div>
            <p>Lead has been added!</p>
            <p className="py-5 text-white font-bold">Please Fill KYC details</p>
          </div>,
          3000,
          'top-center'
        );
      }
    }
  },
  {
    id: 'ThanksMessage',
    component: () => {
      navigate(`/app/UserKyc`);
      return <></>;
    }
  }
];
export default Steps;
